import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROXYVOTE_JOB_BASE_PATH } from '../../../../../../../../features/proxyvote/job/proxyvote-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/')({
  beforeLoad: () => {
    throw redirect({ to: PROXYVOTE_JOB_BASE_PATH });
  },
  preload: false,
});
